import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface ActivityLogsStoreState {
  activityOperations: any[];
  activityDetails: any[];
  activityTotalRecords: number;
  upgradePathPopup: {
    product: any[];
    model: any[];
    currentVersion: any[];
    upgradeToVersion: any[];
  };
}
export default {
  state: {
    activityOperations: [],
    activityDetails: [],
    activityTotalRecords: 0,
    upgradePathPopup: {
      product: [],
      model: [],
      currentVersion: [],
      upgradeToVersion: [],
    },
  },
  mutations: {
    setActivityOperations(state, payload) {
      state.activityOperations = payload;
    },
    setActivityDetails(state, payload) {
      state.activityDetails = payload;
    },
    setActivityTotalRecords(state: any, payload: any) {
      state.activityTotalRecords = payload;
    },
  },
  actions: {
    getUserDetails(context: ActionContext<ActivityLogsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'user/activity-details';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getActivityOperations(context: ActionContext<ActivityLogsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `user/activity-filters?username=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCompleteDetails(context: ActionContext<ActivityLogsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `user/activity-complete-details?activityId=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    fetchActivitySubFilters(context: ActionContext<ActivityLogsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'user/activity-filter-input';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
    getActivityDetails: state => state.activityDetails,
    getOperationTypes: state => state.activityOperations,
    getActivityTotalRecords: state => state.activityTotalRecords,
  },
  namespaced: true,
} as Module<ActivityLogsStoreState, RootStoreState>;
